import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    primarybackground: '',
    secondarybackground: '',
    textareacolor: '',
    textcolor: '',
    textstyle: '',
    textareaborder: '',
    message: '',
    hashtag: '',
    icon: '',
    options: '',
    share: false,
    mantrapage: false,
    locale: ''
  },
  mutations: {
    updateBackgroundState(state, data) {
      this.state[data.background] = data.value;
    },
    updateFontColor(state, data) {
      this.state.textcolor = data.color;
    },
    updateIncludeIcon(state, data) {
      this.state.icon = data.icon;
    },
    updateHashtag(state, data) {
      this.state.hashtag = data.hashtag;
    },
    updateMessage(state, data) {
      this.state.message = data.message;
    },
    updateOptions(state, data) {
      this.state.options = data.options;
    },
    updateShare(state, data) {
      this.state.share = data;
    },
    updateMantrapage(state, data) {
      this.state.mantrapage = data;
    },
    updateLocale(state, data) {
      this.state.locale = data.locale;
    },
    handleButton(state, data) {
      this.state[data.target] = data.value;
    },
    updateStore(state, data) {
      this.state.primarybackground = data.primarybackground || this.state.primarybackground
      this.state.secondarybackground = data.secondarybackground || this.state.secondarybackground
      this.state.textareacolor = data.textareacolor || this.state.textareacolor
      this.state.textcolor = data.textcolor || this.state.textcolor
      this.state.textstyle = data.textstyle || this.state.textstyle
      this.state.textareaborder = data.textareaborder || this.state.textareaborder
      this.state.message = data.message || this.state.message
      this.state.hashtag = data.hashtag || this.state.hashtag
      this.state.icon = data.icon || this.state.icon
      this.state.options = data.options || this.state.options
      this.state.locale = data.locale || this.state.locale
    }
  },
  actions: {
    updateBackgroundState(context, data) {
      context.commit('updateBackgroundState', data);
    },
    updateFontColor(context, data) {
      context.commit('updateFontColor', data);
    },
    updateIncludeIcon(context, data) {
      context.commit('updateIncludeIcon', data);
    },
    updateHashtag(context, data) {
      context.commit('updateHashtag', data);
    },
    updateMessage(context, data) {
      context.commit('updateMessage', data);
    },
    updateOptions(context, data) {
      context.commit('updateOptions', data);
    },
    updateStore(context, data) {
      context.commit('updateStore', data);
    },
    updateShare(context, data) {
      context.commit('updateShare', data);
    },
    updateMantrapage(context, data) {
      context.commit('updateMantrapage', data);
    },
    updateLocale(context, data) {
      context.commit('updateLocale', data);
    },
    handleButton(context, data) {
      context.commit('handleButton', data);
    }
  }
})
